import { Column, ColumnType, EditModule, type EditSettings, FilterModule, Grid, PagerModule} from "@syncfusion/react-grid";


import { useEffect, useState } from "react";
import { UsersDataSource } from "../services/users-data-source";

const modules = { EditModule, FilterModule, PagerModule };

export const UsersPage = () => {

    
    const [toolbar] = useState<string[]>(["Add", "Edit", "Delete", "Update", "Cancel"]);
    const [editSettings] = useState<EditSettings>({mode:'Normal', allowEdit: true, allowAdd: true, allowDelete: true});

    const dataSource = new UsersDataSource();


    useEffect(() => {
        dataSource.get()
    }, []);


    return (
        <div>
            <Grid height={500}
            toolbar={toolbar}
            dataSource={dataSource.data}
            modules={modules} 
            onDataRequest={()=>dataSource.get()}
            onDataChangeStart={dataSource.dataChangeStart}
            pageSettings={dataSource.pageSettings}
            editSettings={editSettings}
            >
                <Column field="id" isPrimaryKey={true} isIdentity={true} validationRules={{required: false}} visible={false}/>
                <Column field="userName" validationRules={{required: true, minLength: 4}}  headerText="Usuario"/>
                <Column field="email" validationRules={{required: true, email: true}} headerText="Email"/>
                <Column 
                field="createdAt" 
                headerText="Creado" 
                type={ColumnType.DateTime} 
                format={{type:'date', format: 'dd/MM/yyyy HH:mm:ss'}} 
                editTemplate={<p></p>}
                validationRules={{required: false}} 
                allowEdit={false}/>
                <Column 
                field="updatedAt" 
                headerText="Actualizado" 
                type={ColumnType.DateTime} 
                format={{type:'date', format: 'dd/MM/yyyy HH:mm:ss'}} 
                editTemplate={<p></p>}
                validationRules={{required: false}} 
                allowEdit={false}/>

            </Grid>
        </div>
    );
};